import styled from "styled-components";

export const PaySlipSc = styled.div`
  width: 100vw;
  position: absolute;
  top: 50px;
  padding: 10px;
  .inner-container {
    display: flex;
    flex-direction: column;
  }
  .inner-content {
    display: flex;
    justify-content: space-between;
    gap: 5px;
    padding: 1rem;
  }
  .inner-content > div {
    width: 40%;
    margin: 5px;
  }
  .pf-insurance {
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .buttons-class {
    display: flex;
    justify-content: end;
    gap: 10px;
  }
`;
